import ProductCarouselComponent from '../svelte/ProductCarousel.svelte';
import fetchFromStorefront from '../utils/storefront.js';

class ProductCarousel extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector('[data-product-carousel]');
    this.collections = JSON.parse(this.carousel.dataset.collections);
    this.sectionSettings = JSON.parse(this.carousel.dataset.sectionSettings);
    this.productHandle = this.querySelector(
      '[data-product-carousel]'
    ).dataset.handle;

    this.init();
  }

  // eslint-disable-next-line class-methods-use-this
  getFilterData(handle) {
    const query = `
    query t {
      collection(handle: "${handle}") {
        handle
        products(first: 3) {
           edges {
            node {
              title
            }
          }
        }
      }
    }
      `;

    return fetchFromStorefront(query);
  }

  init() {
    // eslint-disable-next-line no-new
    new ProductCarouselComponent({
      target: this.carousel,
      props: {
        collections: this.collections,
        sectionSettings: this.sectionSettings,
        productHandle: this.productHandle,
      },
    });
  }
}

customElements.define('product-carousel', ProductCarousel);
